// import React from "react";
// import aboutbanner from "../assets/aboutbanner.jpg";
// import PosterOne from "../share/component.jsx/posterone";

// function ExpertDiagnosticsSpecialist() {
//   return (
//     <div>
//       <PosterOne img={aboutbanner} title={"Expert Diagnostics Specialist Services"} />
//       <h1>ExpertDiagnosticsSpecialist</h1>
//       <h2>ExpertDiagnosticsSpecialist</h2>
//       <h3>ExpertDiagnosticsSpecialist</h3>
//     </div>
//   );
// }

// export default ExpertDiagnosticsSpecialist;



import { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import PosterOne from "../share/component.jsx/posterone";
import aboutbanner from "../assets/aboutbanner.jpg";
import BannerOne from "../share/component.jsx/banner";

/* ─── ANIMATED HEARTBEAT LINE ────────────────────────── */
const HeartbeatLine = ({ color = "#c0392b", width = 320, height = 48 }) => {
  const pathRef = useRef(null);
  useEffect(() => {
    const el = pathRef.current;
    if (!el) return;
    const len = el.getTotalLength();
    el.style.strokeDasharray = len;
    el.style.strokeDashoffset = len;
    el.style.animation = "ecg-draw 2.2s ease forwards";
  }, []);
  return (
    <svg viewBox={`0 0 ${width} ${height}`} width={width} height={height} fill="none" style={{ overflow: "visible" }}>
      <style>{`@keyframes ecg-draw{to{stroke-dashoffset:0}}`}</style>
      <path
        ref={pathRef}
        d={`M0,${height/2} L${width*0.15},${height/2} L${width*0.22},${height/2-2} L${width*0.27},${height/2+2} L${width*0.32},4 L${width*0.38},${height-4} L${width*0.43},${height/2-8} L${width*0.48},${height/2} L${width*0.55},${height/2} L${width*0.60},${height/2-2} L${width*0.65},${height/2+2} L${width*0.70},6 L${width*0.76},${height-6} L${width*0.81},${height/2-6} L${width*0.86},${height/2} L${width},${height/2}`}
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

/* ─── PULSING HEART SVG ──────────────────────────────── */
const PulsingHeart = () => (
  <svg viewBox="0 0 80 72" width={80} height={72} fill="none" style={{ animation: "heartbeat 1.4s ease-in-out infinite", transformOrigin: "center" }}>
    <style>{`@keyframes heartbeat{0%,100%{transform:scale(1)}14%{transform:scale(1.15)}28%{transform:scale(1)}42%{transform:scale(1.08)}70%{transform:scale(1)}}`}</style>
    <path d="M40 68 C40 68 6 48 6 24 C6 13 15 4 26 4 C32 4 38 7 40 12 C42 7 48 4 54 4 C65 4 74 13 74 24 C74 48 40 68 40 68Z" fill="url(#hg)" />
    <defs>
      <linearGradient id="hg" x1="40" y1="4" x2="40" y2="68" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#e74c3c" />
        <stop offset="100%" stopColor="#8e1a0e" />
      </linearGradient>
    </defs>
  </svg>
);

/* ─── ANIMATED COUNTER ───────────────────────────────── */
const Counter = ({ value }) => {
  const [d, setD] = useState("0");
  const ref = useRef(null);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) {
        const num = parseFloat(value.replace(/[^0-9.]/g, ""));
        const suf = value.replace(/[0-9.]/g, "");
        let s = 0; const step = num / 45;
        const t = setInterval(() => {
          s += step;
          if (s >= num) { setD(value); clearInterval(t); }
          else setD(Math.floor(s) + suf);
        }, 28);
        obs.disconnect();
      }
    }, { threshold: 0.5 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [value]);
  return <span ref={ref}>{d}</span>;
};

/* ─── DATA ───────────────────────────────────────────── */
const TESTS = [
  { image: require('../assets/services/Electrocardiogram.jpg'), code: "ECG", name: "Electrocardiogram", desc: "We offer comprehensive 12-lead ECG interpretation of arrhythmias, ischemic changes, conduction defects, rhythm abnormalities, interval abnormalities, and any other electrical issues. Each review aims at relating ECG results with symptoms, medical history, and the most recommended action to take in care." },
  { image: require('../assets/services/Echocardiogram.jpg'), code: "ECHO", name: "Echocardiogram", desc: "Our experts look at reports of 2D and 3D echocardiograms, Doppler findings, strain imaging, valve function, chamber size, LV function, cardiomyopathy signs, and pericardial effusion. We describe what the findings imply and how they impact your treatment plan." },
  { image: require('../assets/services/Coronary Angiogram.jpg'), code: "ANGIO", name: "Coronary Angiogram", desc: "We review reports of catheterization and angiography with attention to the severity of stenosis, vessel involvement, TIMI flow, collateral circulation, lesion complexity, and previous intervention history. Our specialist appraisal assists patients in understanding whether medication, stenting, bypass, or further examination might be suitable." },
  { image: require('../assets/services/Stress Test  TMT.jpg'), code: "STRESS", name: "Stress Test / TMT", desc: "We interpret exercise and pharmacological stress tests, including ST-segment changes, Duke treadmill score, exercise tolerance, blood pressure response, heart rhythm changes, and risk level. This assists patients in knowing whether symptoms can be associated with diminished blood circulation." },
  { image: require('../assets/services/CT Coronary Angiography.jpg'), code: "CT ANGIO", name: "CT Coronary Angiography", desc: "We examine CT coronary angiography reports with attention to calcium score, type of plaque, level of stenosis, vessel constriction, and CAD-RADS classification. This assists in guiding risk-based management, preventive care, additional testing, and coronary artery disease treatment planning." },
  { image: require('../assets/services/Cardiac MRI.jpg'), code: "MRI", name: "Cardiac MRI", desc: "Our cardiac MRI review comprises evaluation of LVEF, tissue viability, fibrosis, myocarditis, sarcoidosis, ARVC, congenital heart disease morphology, and complex findings. We assist patients in realizing that advanced imaging can be described in easy-to-understand language." },
];

const OPINIONS = [
  { id: 1, image: require('../assets/services/Expert Virtual Opinion.jpg'), title: "Expert Virtual Opinion", sub: "From Board-Certified Interventional Cardiologist", desc: "Obtain a detailed written recommendation from an expert considered one of the best interventional cardiologists in the USA. This service assists patients in learning about angiogram results, stent choices, complicated blockages, and less-invasive treatment opportunities without the need to travel." },
  { id: 2, image: require('../assets/services/High risk case evaluation.jpg'), title: "High-Risk Case Evaluation", sub: "Surgical Need & Operative Risk Assessment", desc: "For patients going through significant cardiac operations, we provide objective risk assessments, procedure appropriateness, interpretation of EuroSCORE or STS, and advice on surgical versus percutaneous operation. This allows patients to be aware of advantages, constraints, and dangers prior to making high-impact treatment choices." },
  { id: 3, image: require('../assets/services/Complex & Borderline Case Review.jpg'), title: "Complex & Borderline Case Review", sub: "Before Major Decisions", desc: "We examine borderline FFR/iFR, multivessel, left main lesions, recurrent symptoms, and contradictory recommendations. Our experts offer unbiased advice to help patients make the right choice regarding the next action to take that is the safest and most suitable." },
  { id: 4, image: require('../assets/services/Heart Failure Assessment.jpg'), title: "Heart Failure Assessment", sub: "Advanced HF Specialist Review", desc: "Our heart failure doctors offer advanced assessment of patients with compromised heart performance, frequent hospitalizations, challenging symptoms, or complicated medication requirements. Care involves GDMT optimization, LVAD candidacy review, transplant eligibility discussion, CRT assessment, and device therapy planning." },
];

const STATS = [
  { val: "25+", lbl: "Years of Excellence" },
  { val: "40K+", lbl: "Cases Reviewed" },
  { val: "98%", lbl: "Patient Satisfaction" },
  { val: "#1", lbl: "Ranked in USA" },
];

const KEYWORDS = [
  "Heart Cardiologist", "Best Heart Surgeon", "Best Cardiovascular Doctors",
  "Best Cardiologist for Heart Disease in USA", "Best Interventional Cardiologist in USA",
  "Heart Failure Doctors", "Cardiovascular Doctor",
];

const HOW = [
  { num: "01", title: "Upload Your Reports", desc: "Our secure patient portal allows you to upload your ECG, echocardiogram, angiogram, stress test, CT coronary angiography, cardiac MRI, medication list, and clinical history. Your documents are arranged in our team prior to review by specialists." },
  { num: "02", title: "Matched to Your Specialist", desc: "Your case is referred to the most appropriate expert depending on your conditions, type of report, and needs. We match you with the top level of specialist care in heart failure through virtual access, whether your concern is coronary disease, rhythm problems, valve disease, or advanced heart failure." },
  { num: "03", title: "Receive Written Expert Opinion", desc: "Within 48–72 hours, get a detailed written opinion which explains important findings, risk factors, treatment considerations, and recommended next steps. The report is structured to be easily comprehensible to patients, yet still be clinically useful for discussions of ongoing care." },
  { num: "04", title: "Follow-up Consultation", desc: "You can book a 30-minute live video meeting with your assigned cardiologist as an option. In this session, you will be able to discuss your report, ask questions, review treatment options, and understand how the expert opinion applies to your personal cardiac care journey." },
];

/* ─── TEST CARD ──────────────────────────────────────── */
const TestCard = ({ t, i }) => {
  return (
    <div
      style={{
        background: "#fff",
        border: `1px solid #f0e0dc`,
        borderRadius: 18,
        padding: "28px 24px",
        cursor: "default",
        display: "flex", flexDirection: "column",


      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16 }}>
        <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", transition: "background 0.3s" }}>
          {t.image ? (
            <img src={t.image} alt={t.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{t.icon}</span>
          )}
        </div>
        <span style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 13, letterSpacing: "0.18em", color: "#fff", padding: "4px 10px", borderRadius: 20, background: "#2de23a" }}>{t.code}</span>
      </div>
      <h3 style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: 18, fontWeight: 700, color: "#2c1010", margin: "0 0 10px", lineHeight: 1.3, letterSpacing: "-0.01em" }}>{t.name}</h3>
      <p style={{ fontSize: 13, color: "#7a5050", lineHeight: 1.78, fontFamily: "'Crimson Pro', Georgia, serif", margin: 0 }}>{t.desc}</p>
    </div>
  );
};

/* ─── OPINION CARD ───────────────────────────────────── */
const OpinionCard = ({ o }) => {
  return (
    <div
      style={{
        background: o.highlight
          ? "linear-gradient(145deg,#8e1a0e 0%,#5a0e0e 100%)"
          : "#fff",
        border: o.highlight ? "none" : `1.5px solid #f0e0dc`,
        borderRadius: 20,
        padding: "34px 30px",
        cursor: "default", position: "relative", overflow: "hidden",
      }}
    >
      {o.highlight && (
        <div style={{ position: "absolute", top: 16, right: 20, background: "rgba(255,255,255,0.12)", borderRadius: 20, padding: "3px 12px", fontSize: 10, fontFamily: "'Bebas Neue', sans-serif", letterSpacing: "0.14em", color: "rgba(255,255,255,0.7)" }}>MOST REQUESTED</div>
      )}
      <div style={{ width: 70, height: 70, borderRadius: 14,  display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", marginBottom: 15}}>
          {o.image ? (
            <img src={o.image} alt={o.title} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <span style={{ fontSize: 24 }}>{o.icon}</span>
          )}
        </div>
      <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, fontWeight: 700, color: o.highlight ? "#fff" : "#2c1010", margin: "0 0 6px", letterSpacing: "-0.01em", lineHeight: 1.2 }}>{o.title}</h3>
      <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: o.highlight ? "rgba(255,200,180,0.7)" : "#c0392b", margin: "0 0 14px", fontFamily: "'Bebas Neue', sans-serif" }}>{o.sub}</p>
      <p style={{ fontSize: 14, color: o.highlight ? "rgba(255,255,255,0.78)" : "#7a5050", lineHeight: 1.78, fontFamily: "'Crimson Pro', serif", margin: 0 }}>{o.desc}</p>
    </div>
  );
};

/* ─── MAIN ───────────────────────────────────────────── */
export default function ExpertDiagnosticsSpecialist() {
  const navigate = useNavigate();
  const [activeHow, setActiveHow] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const t = setInterval(() => setActiveHow(p => (p + 1) % HOW.length), 3000);
    return () => clearInterval(t);
  }, []);

  return (
    <>
      <Helmet>
        <title>Best Heart Cardiologist &amp; Cardiovascular Doctors USA</title>
        <meta
          name="description"
          content="Expert heart cardiologists, top heart surgeons, and trusted heart failure doctors in the USA and China for advanced, personalized heart care."
        />
      </Helmet>

      <style>{`
        
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

        :root {
          --crimson: #8e1a0e;
          --red: #2de23a;
          --rose: #e8c0bc;
          --parchment: #fff;
          --warm-white: #fff;
          --ink: #1e0a0a;
          --muted: #888888;
          --gold: #c9a84c;
        }

        .ed-root { font-family: 'Hind', sans-serif; background: var(--warm-white); color: var(--ink); overflow-x: hidden; }

        /* NAV */
        .ed-nav {
          position: sticky; top: 0; z-index: 100;
          background: rgba(30,10,10,0.97);
          backdrop-filter: blur(16px);
          padding: 0 56px;
          display: flex; align-items: center; justify-content: space-between;
          height: 70px;
          border-bottom: 1px solid rgba(255,255,255,0.06);
        }
        .ed-logo { display: flex; align-items: center; gap: 12px; text-decoration: none; }
        .ed-logo-heart { width: 42px; height: 42px; display: flex; align-items: center; justify-content: center; }
        .ed-logo-heart svg { width: 32px; height: 28px; }
        .ed-logo-heart svg path { fill: url(#lhg); }
        .ed-logo-text { font-family: 'Cormorant Garamond', serif; font-size: 19px; font-weight: 700; color: #fff; letter-spacing: -0.01em; line-height: 1.2; }
        .ed-logo-sub { display: block; font-size: 9px; color: rgba(255,255,255,0.35); letter-spacing: 0.16em; text-transform: uppercase; font-family: 'Hind', sans-serif; font-weight: 400; }
        .ed-nav-links { display: flex; gap: 28px; list-style: none; }
        .ed-nav-links a { text-decoration: none; font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.5); transition: color 0.2s; }
        .ed-nav-links a:hover { color: #fff; }
        .ed-nav-right { display: flex; gap: 10px; align-items: center; }
        .ed-btn-ghost { background: rgba(255,255,255,0.06); color: rgba(255,255,255,0.75); border: 1px solid rgba(255,255,255,0.12); padding: 9px 20px; border-radius: 30px; font-size: 13px; font-weight: 600; cursor: pointer; font-family: 'Hind', sans-serif; transition: all 0.2s; }
        .ed-btn-ghost:hover { background: rgba(255,255,255,0.12); }
        .ed-btn-cta { background: linear-gradient(135deg, var(--red), var(--crimson)); color: #fff; border: none; padding: 10px 22px; border-radius: 30px; font-size: 13px; font-weight: 700; cursor: pointer; font-family: 'Hind', sans-serif; transition: all 0.2s; box-shadow: 0 4px 16px rgba(192,57,43,0.4); }
        .ed-btn-cta:hover { opacity: 0.9; transform: translateY(-1px); }
        .ed-hamburger { display: none; background: none; border: none; color: #fff; font-size: 22px; cursor: pointer; }

        /* HERO */
        .ed-hero {
          background: var(--ink);
          position: relative; overflow: hidden;
          min-height: 95vh;
          display: grid;
          grid-template-columns: 55% 45%;
        }
        .ed-hero-left {
          padding: 110px 56px 80px;
          display: flex; flex-direction: column; justify-content: center;
          position: relative; z-index: 2;
        }
        .ed-hero-right {
          position: relative; z-index: 2;
          background: rgba(255,255,255,0.02);
          border-left: 1px solid rgba(255,255,255,0.05);
          display: flex; flex-direction: column; justify-content: center;
          padding: 60px 48px;
          gap: 16px;
        }
        .ed-hero::before {
          content: '';
          position: absolute; inset: 0;
          background:
            radial-gradient(ellipse 50% 60% at 100% 40%, rgba(142,26,14,0.22) 0%, transparent 65%),
            radial-gradient(ellipse 35% 45% at 5% 85%, rgba(201,168,76,0.06) 0%, transparent 60%);
          pointer-events: none; z-index: 1;
        }
        .ed-hero-noise {
          position: absolute; inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.04'/%3E%3C/svg%3E");
          opacity: 0.3; pointer-events: none; z-index: 1;
        }

        .ed-badge {
          display: inline-flex; align-items: center; gap: 8px;
          background: rgba(192,57,43,0.15);
          border: 1px solid rgba(192,57,43,0.4);
          color: #f0a090;
          font-size: 10.5px; font-weight: 600;
          letter-spacing: 0.14em; text-transform: uppercase;
          padding: 6px 16px; border-radius: 30px;
          margin-bottom: 28px; width: fit-content;
          font-family: 'Hind', sans-serif;
        }
        .ed-badge-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--red); animation: edpulse 1.6s ease infinite; }
        @keyframes edpulse { 0%,100%{opacity:1} 50%{opacity:0.3} }

        .ed-hero-h1 {
          font-family: 'Cormorant Garamond', Georgia, serif;
          font-size: clamp(36px, 5vw, 72px);
          font-weight: 700;
          color: #fff;
          line-height: 1.06;
          letter-spacing: -0.03em;
          margin-bottom: 26px;
        }
        .ed-hero-h1 em { font-style: italic; color: #e07060; }
        .ed-hero-h1 span { color: var(--gold); }

        .ed-hero-sub { font-size: 16.5px; line-height: 1.82; color: rgba(255,255,255,0.55); font-family: 'Crimson Pro', serif; margin-bottom: 42px; max-width: 460px; }

        .ed-hero-btns { display: flex; gap: 14px; flex-wrap: wrap; margin-bottom: 52px; }
        .btn-hero-primary {
          background: linear-gradient(135deg, var(--red), var(--crimson));
          color: #fff; border: none;
          padding: 16px 34px; border-radius: 40px;
          font-size: 14px; font-weight: 700;
          cursor: pointer; font-family: 'Hind', sans-serif;
          box-shadow: 0 8px 28px rgba(192,57,43,0.45);
          transition: all 0.25s; letter-spacing: 0.02em;
        }
        .btn-hero-primary:hover { transform: translateY(-2px); box-shadow: 0 12px 36px rgba(192,57,43,0.55); }
        .btn-hero-outline {
          background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.8);
          border: 1.5px solid rgba(255,255,255,0.18);
          padding: 16px 32px; border-radius: 40px;
          font-size: 14px; font-weight: 600;
          cursor: pointer; font-family: 'Hind', sans-serif;
          transition: all 0.25s;
        }
        .btn-hero-outline:hover { background: rgba(255,255,255,0.1); }
        .ed-ecg { margin-bottom: 20px; }

        /* trust badges */
        .ed-trust { display: flex; flex-wrap: wrap; gap: 10px; }
        .ed-trust-badge {
          display: flex; align-items: center; gap: 7px;
          background: rgba(255,255,255,0.05);
          border: 1px solid rgba(255,255,255,0.08);
          border-radius: 30px; padding: 7px 14px;
          font-size: 12px; font-weight: 500;
          color: rgba(255,255,255,0.55);
        }
        .ed-trust-badge span:first-child { font-size: 14px; }

        /* RIGHT PANEL — quick stats */
        .ed-right-panel-title { font-family: 'Bebas Neue', sans-serif; font-size: 11px; letter-spacing: 0.2em; color: rgba(255,255,255,0.22); text-transform: uppercase; margin-bottom: 4px; }
        .ed-stat-card {
          background: rgba(255,255,255,0.04);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 16px; padding: 22px 24px;
          transition: all 0.25s;
        }
        .ed-stat-card:hover { background: rgba(192,57,43,0.1); border-color: rgba(192,57,43,0.3); }
        .ed-stat-card-val { font-family: 'Cormorant Garamond', serif; font-size: 38px; font-weight: 700; color: #e07060; line-height: 1; letter-spacing: -0.03em; }
        .ed-stat-card-lbl { font-size: 12px; color: rgba(255,255,255,0.4); margin-top: 4px; letter-spacing: 0.04em; font-family: 'Hind', sans-serif; }
        .ed-stat-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .ed-availability {
          background: rgba(14,159,142,0.1); border: 1px solid rgba(14,159,142,0.3);
          border-radius: 14px; padding: 18px 22px;
          display: flex; align-items: center; gap: 14px;
        }
        .ed-avail-dot { width: 10px; height: 10px; border-radius: 50%; background: #0e9f8e; animation: edpulse 1.6s ease infinite; flex-shrink: 0; }
        .ed-avail-text { font-size: 13px; color: rgba(255,255,255,0.65); font-family: 'Crimson Pro', serif; line-height: 1.5; }
        .ed-avail-text strong { color: #5de0cc; font-weight: 600; }

        /* STATS BAR */
        .ed-stats {
          background: linear-gradient(135deg, #7b1818 0%, #3d0808 100%);
          display: flex; justify-content: center; flex-wrap: wrap;
          padding: 44px 56px;
        }
        .ed-stat { flex: 1; min-width: 160px; text-align: center; padding: 12px 24px; position: relative; }
        .ed-stat:not(:last-child)::after { content: ''; position: absolute; right: 0; top: 20%; height: 60%; width: 1px; background: rgba(255,255,255,0.12); }
        .ed-stat-val { display: block; font-family: 'Cormorant Garamond', serif; font-size: clamp(32px,4vw,52px); font-weight: 700; color: #f0a090; line-height: 1; letter-spacing: -0.02em; }
        .ed-stat-lbl { display: block; font-size: 11px; font-weight: 600; color: rgba(255,255,255,0.45); letter-spacing: 0.14em; text-transform: uppercase; margin-top: 7px; font-family: 'Hind', sans-serif; }

        /* TESTS */
        .ed-tests { background: var(--parchment); padding: 100px 56px; }
        .ed-tests-inner { max-width: 1240px; margin: 0 auto; }
        .ed-eyebrow { font-size: 10.5px; font-weight: 700; letter-spacing: 0.22em; text-transform: uppercase; color: var(--red); margin-bottom: 10px; font-family: 'Hind', sans-serif; }
        .ed-h2 { font-family: 'Cormorant Garamond', serif; font-size: clamp(28px,3.8vw,50px); font-weight: 700; color: var(--ink); letter-spacing: -0.025em; line-height: 1.1; margin-bottom: 14px; }
        .ed-h2 em { font-style: italic; color: var(--red); }
        .ed-desc { font-size: 16px; color: var(--muted); line-height: 1.8; font-family: 'Crimson Pro', serif; max-width: 580px; margin-bottom: 52px; }
        .ed-tests-grid { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; }

        /* OPINIONS */
        .ed-opinions { background: var(--warm-white); padding: 100px 56px; }
        .ed-opinions-inner { max-width: 1240px; margin: 0 auto; }
        .ed-opinions-grid { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }

        /* HOW IT WORKS */
        .ed-how { background: var(--ink); padding: 100px 56px; }
        .ed-how-inner { max-width: 1240px; margin: 0 auto; }
        .ed-how-layout { display: grid; grid-template-columns: 1fr 1.1fr; gap: 80px; align-items: start; margin-top: 52px; }
        .ed-how-steps { display: flex; flex-direction: column; gap: 6px; }
        .ed-how-step {
          display: flex; align-items: flex-start; gap: 18px;
          padding: 20px 22px; border-radius: 16px;
          cursor: pointer; transition: all 0.28s;
          border: 1px solid transparent;
        }
        .ed-how-step.active { background: rgba(192,57,43,0.1); border-color: rgba(192,57,43,0.3); }
        .ed-how-num { font-family: 'Bebas Neue', sans-serif; font-size: 12px; letter-spacing: 0.1em; color: var(--rose); flex-shrink: 0; padding-top: 3px; }
        .ed-how-step.active .ed-how-num { color: #e07060; }
        .ed-how-title { font-family: 'Cormorant Garamond', serif; font-size: 17px; font-weight: 700; color: rgba(255,255,255,0.7); margin-bottom: 5px; transition: color 0.25s; }
        .ed-how-step.active .ed-how-title { color: #fff; }
        .ed-how-desc { font-size: 13px; color: rgba(255,255,255,0.35); line-height: 1.7; font-family: 'Crimson Pro', serif; transition: color 0.25s; }
        .ed-how-step.active .ed-how-desc { color: rgba(255,255,255,0.58); }
        .ed-how-panel {
          background: rgba(255,255,255,0.03);
          border: 1px solid rgba(255,255,255,0.07);
          border-radius: 22px; padding: 44px;
          position: sticky; top: 100px;
        }
        .ed-how-panel-step { font-family: 'Bebas Neue', sans-serif; font-size: 10px; letter-spacing: 0.22em; color: rgba(255,255,255,0.2); text-transform: uppercase; margin-bottom: 18px; }
        .ed-how-panel-title { font-family: 'Cormorant Garamond', serif; font-size: 30px; font-weight: 700; color: #fff; line-height: 1.2; margin-bottom: 18px; letter-spacing: -0.02em; }
        .ed-how-panel-desc { font-size: 15px; color: rgba(255,255,255,0.52); line-height: 1.8; font-family: 'Crimson Pro', serif; margin-bottom: 32px; }
        .ed-progress { background: rgba(255,255,255,0.06); border-radius: 4px; height: 3px; overflow: hidden; }
        .ed-progress-fill { height: 100%; background: linear-gradient(90deg, var(--red), #e07060); border-radius: 4px; transition: width 0.4s ease; }

        /* KEYWORDS */
        .ed-keywords { background: var(--parchment); padding: 64px 56px; }
        .ed-keywords-inner { max-width: 1240px; margin: 0 auto; }
        .ed-kw-title { font-family: 'Bebas Neue', sans-serif; font-size: 11px; letter-spacing: 0.2em; color: var(--muted); text-transform: uppercase; margin-bottom: 20px; }
        .ed-kw-grid { display: flex; flex-wrap: wrap; gap: 10px; }
        .ed-kw-pill { font-size: 13px; font-weight: 500; padding: 10px 22px; border-radius: 30px; background: #fff; color: var(--ink); border: 1.5px solid #f0e0dc; cursor: default; transition: all 0.22s; font-family: 'Crimson Pro', serif; }
        .ed-kw-pill:hover { background: var(--red); color: #fff; border-color: var(--red); transform: translateY(-2px); box-shadow: 0 6px 20px rgba(192,57,43,0.3); }

        /* CTA */
        .ed-cta {
          background: linear-gradient(145deg, #1e0a0a 0%, #3d0c0c 100%);
          padding: 100px 56px;
          display: grid; grid-template-columns: 1fr 1fr; gap: 80px; align-items: center;
          position: relative; overflow: hidden;
        }
        .ed-cta::before {
          content: ''; position: absolute; inset: 0;
          background: radial-gradient(ellipse 50% 70% at 90% 50%, rgba(192,57,43,0.2) 0%, transparent 65%);
          pointer-events: none;
        }
        .ed-cta-form {
          background: rgba(255,255,255,0.97);
          border-radius: 24px; padding: 44px;
          box-shadow: 0 24px 64px rgba(0,0,0,0.4);
          position: relative; z-index: 2;
        }
        .ed-form-title { font-family: 'Cormorant Garamond', serif; font-size: 24px; font-weight: 700; color: var(--ink); margin-bottom: 6px; }
        .ed-form-sub { font-size: 13.5px; color: var(--muted); font-family: 'Crimson Pro', serif; margin-bottom: 26px; }
        .ed-fg { margin-bottom: 14px; }
        .ed-fg label { display: block; font-size: 11px; font-weight: 700; letter-spacing: 0.08em; text-transform: uppercase; color: var(--ink); margin-bottom: 5px; font-family: 'Hind', sans-serif; }
        .ed-fg input, .ed-fg select, .ed-fg textarea { width: 100%; padding: 12px 15px; border: 1.5px solid #f0e0dc; border-radius: 10px; font-size: 14px; color: var(--ink); font-family: 'Hind', sans-serif; background: var(--warm-white); outline: none; transition: border-color 0.2s; }
        .ed-fg input:focus, .ed-fg select:focus, .ed-fg textarea:focus { border-color: var(--red); background: #fff; }
        .ed-form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
        .ed-submit { width: 100%; background: linear-gradient(135deg, var(--red), var(--crimson)); color: #fff; border: none; padding: 15px; border-radius: 12px; font-size: 15px; font-weight: 700; cursor: pointer; font-family: 'Hind', sans-serif; margin-top: 8px; box-shadow: 0 6px 24px rgba(192,57,43,0.4); transition: all 0.25s; letter-spacing: 0.02em; }
        .ed-submit:hover { opacity: 0.92; transform: translateY(-1px); }

        /* FOOTER */
        .ed-footer { background: #0e0505; border-top: 1px solid rgba(255,255,255,0.05); padding: 26px 56px; display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
        .ed-footer p { font-size: 12px; color: rgba(255,255,255,0.25); }
        .ed-footer-kws { display: flex; gap: 8px; flex-wrap: wrap; }
        .ed-footer-kw { font-size: 10px; color: rgba(192,57,43,0.7); background: rgba(192,57,43,0.08); padding: 3px 10px; border-radius: 20px; letter-spacing: 0.03em; }

        /* RESPONSIVE */
        @media (max-width: 1024px) {
          .ed-hero { grid-template-columns: 1fr; }
          .ed-hero-right { display: none; }
          .ed-how-layout { grid-template-columns: 1fr; }
          .ed-cta { grid-template-columns: 1fr; gap: 48px; }
        }
        @media (max-width: 900px) {
          .ed-nav { padding: 0 24px; }
          .ed-nav-links, .ed-nav-right { display: none; }
          .ed-hamburger { display: block; }
          .ed-tests-grid { grid-template-columns: repeat(2,1fr); }
          .ed-opinions-grid { grid-template-columns: 1fr; }
        }
        @media (max-width: 580px) {
          .ed-hero-left { padding: 80px 24px 60px; }
          .ed-stats { padding: 32px 20px; }
          .ed-stat:not(:last-child)::after { display: none; }
          .ed-tests, .ed-opinions, .ed-how, .ed-keywords, .ed-cta { padding: 60px 24px; }
          .ed-tests-grid { grid-template-columns: 1fr; }
          .ed-form-row { grid-template-columns: 1fr; }
          .ed-footer { padding: 20px 24px; flex-direction: column; align-items: flex-start; }
          .ed-kw-grid { gap: 8px; }
        }
      `}</style>

      <BannerOne
  img={require('../assets/symptoms/diagnosticBanner.png')}
  title={
    <>
      Expert Diagnostics <br /> & <br />
      Specialist Opinions
    </>
  }
/>

      <div className="ed-root acc-root">
        {/* <PosterOne
        img={aboutbanner}
        title={"Expert Diagnostics & Specialist Opinions"}
      /> */}
   
      


        {/* TEST REPORTS */}
        <section className="ed-tests">
          <div className="ed-tests-inner">
            <p className="ed-eyebrow">Report Review Services</p>
            <h2 className="ed-h2">Comprehensive Review of All<br /><em>Cardiac Diagnostic Reports</em></h2>
            <p className="ed-desc">
              The team of our heart cardiologist and cardiovascular doctor reviews all major cardiac investigations and provides clinical accuracy, clear interpretation, and actionable guidance. We assist patients in interpreting complicated reports, comparing results, and making wise decisions on how to proceed with treatment, follow-up treatment, or advanced treatment.
            </p>
            <div className="ed-tests-grid">
              {TESTS.map((t, i) => <TestCard key={t.code} t={t} i={i} />)}
            </div>
          </div>
        </section>

        {/* SPECIALIST OPINIONS */}
        <section className="ed-opinions">
          <div className="ed-opinions-inner">
            <p className="ed-eyebrow">Specialist Opinion Services</p>
            <h2 className="ed-h2">Expert Opinions from the<br /><em>Best Cardiovascular Doctors</em></h2>
            <p className="ed-desc">
              Our team offers reliable advice prior to significant cardiac decisions, be it virtual second opinion consultations or a complicated surgical evaluation. Patients with the best heart surgeon, the best cardiovascular doctors, or advanced cardiac specialists can get a clear and detailed review that can help in building confidence and informed care.
            </p>
            <div className="ed-opinions-grid">
              {OPINIONS.map(o => <OpinionCard key={o.id} o={o} />)}
            </div>
          </div>
        </section>

        {/* HOW IT WORKS */}
        <section className="ed-how">
          <div className="ed-how-inner">
            <p className="ed-eyebrow" style={{ color: "#e07060" }}>How It Works</p>
            <h2 className="ed-h2" style={{ color: "#fff" }}>From Report Upload to<br /><em style={{ color: "#e07060" }}>Expert Opinion</em> in 72 Hours</h2>
            <p className="ed-desc" style={{ color: "rgba(255,255,255,0.45)", marginBottom: 0 }}>
              A patient-friendly and safe process that targets patients who want the best cardiologist for heart disease in the USA, without geographical limitations. On our platform, you can upload reports, hire the appropriate specialist, and get a clear written opinion within a systematic schedule.
            </p>
            <div className="ed-how-layout">
              <div className="ed-how-steps">
                {HOW.map((h, i) => (
                  <div key={h.num} className={`ed-how-step ${activeHow === i ? "active" : ""}`} onClick={() => setActiveHow(i)}>
                    <span className="ed-how-num">{h.num}</span>
                    <div>
                      <div className="ed-how-title">{h.title}</div>
                      <div className="ed-how-desc">{h.desc}</div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="ed-how-panel">
                <div className="ed-how-panel-step">Step {activeHow + 1} of {HOW.length} · {HOW[activeHow].title}</div>
                <div className="ed-how-panel-title">{HOW[activeHow].title}</div>
                <div className="ed-how-panel-desc">{HOW[activeHow].desc}</div>
                <div className="ed-progress">
                  <div className="ed-progress-fill" style={{ width: `${((activeHow + 1) / HOW.length) * 100}%` }} />
                </div>
                <div style={{ fontFamily: "'Hind', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.22)", marginTop: 8, letterSpacing: "0.1em" }}>
                  {activeHow + 1} / {HOW.length} Steps Complete
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* KEYWORDS SECTION */}
        <section className="ed-keywords">
          <div className="ed-keywords-inner">
            <p className="ed-kw-title">Our Cardiology Specialties — Search Expertise</p>
            <div className="ed-kw-grid">
              {KEYWORDS.map(k => (
                <span className="ed-kw-pill" key={k}>{k}</span>
              ))}
            </div>
          </div>
        </section>

        {/* CTA + FORM */}
        <section className="service-cta">
          <div className="service-container">
            <h2>Get a Clear Answer on Your Cardiac Reports</h2>
            <p> Upload your reports today and connect with our specialist team. We will be reviewing your ECG, echocardiogram, angiogram, or imaging results, and the complexity of your case, and deliver a written expert opinion that is accurate, easy to understand, and ready to guide your next step.
</p>
            <div className="service-btns" style={{ justifyContent: 'center' }}>
              <button className="service-btn-primary" onClick={() => navigate('/consultations')}>Get Started</button>
            </div>
          </div>
        </section>

       
      </div>
    </>
  );
}